/**
 * This order should match what is in the db, don't change it unless you really know what you're doing.
 */
export enum ContentGroupTypeEnum {
  GREETING = 1,
  PURPOSE,
  WHEN,
  OPTIONAL,
  SIMPLE,
}
